import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import TitleBar from "../../../../partials/content/TitleBar";
import helperSpinner from "../../../../../helpers/spinner";
import helperNumbers from "../../../../../helpers/numbers";
import helpersTime from "../../../../../helpers/time";
import httpService from "../../../../../services/httpServices/httpServices";
import Pagination from "../../../../partials/content/Pagination";
import StatusAskCheckout from "../StatusAskCheckout";

export default function ManageMarketerAskCheckout() {
  const [allAskCheckoutUserPublisher, setAllAskCheckoutUserPublisher] =
    useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [AskCheckoutID, setAskCheckoutID] = useState(0);

  useEffect(() => {
    getAllAskCheckout();
  }, [currentPage, AskCheckoutID]);

  const getAllAskCheckout = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allAskCheckout = await sendRequestGetAllAskCheckoutUserPublisher(
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allAskCheckout) {
      return;
    }

    setAllAskCheckoutUserPublisher(allAskCheckout.ask_checkout);
    setCountPage(allAskCheckout.count_page);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (AskCheckoutID) {
      searchFilterQuery = `${searchFilterQuery}&id=${AskCheckoutID}`;
    }

    return searchFilterQuery;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const sendRequestGetAllAskCheckoutUserPublisher = async (
    searchFilterQuery
  ) => {
    const headersRequest = getHeaderRequest();
    let allAskCheckout;
    try {
      allAskCheckout = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/marketer/manage/ask-checkout?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allAskCheckout.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateDoseNotHaveAnyAskCheckout = () => {
    return (
      <div className="mt-2 alert alert-info">هیچ تسویه حسابی وجود ندارد.</div>
    );
  };

  const generateAllAskCheckoutUserPublisher = () => {
    return (
      <>
        <div className="alert alert-info mt-2">
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="pl-2">
                <label>جستجو در شماره </label>
              </div>
              <div>
                <input
                  onKeyUp={(e) => setAskCheckoutID(e.target.value)}
                  onWheel={(event) => event.currentTarget.blur()}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره درخواست</td>
                <td>مبلغ</td>
                <td>نام مالک حساب</td>
                <td>نام بانک</td>
                <td>وضعیت</td>
                <td>تاریخ ارسال درخواست</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allAskCheckoutUserPublisher.map((item, index) => {
                let classBadgeStatePage;
                switch (item.mac_status) {
                  case StatusAskCheckout.statusAskCheckout.PENDING:
                    classBadgeStatePage = "badge-warning";
                    break;
                  case StatusAskCheckout.statusAskCheckout.PAID:
                    classBadgeStatePage = "badge-info";
                    break;
                  case StatusAskCheckout.statusAskCheckout.REJECT:
                    classBadgeStatePage = "badge-danger";
                    break;
                }
                return (
                  <tr>
                    <td>{helperNumbers.toPersianNum(index + 1)}</td>
                    <td>{helperNumbers.toPersianNum(item.mac_id)}</td>
                    <td className="letter-spacing-finance-number">
                      {helperNumbers.toPersianNum(
                        helperNumbers.toFormatFinanceNumber(item.mac_price)
                      )}
                    </td>
                    <td>{item.mac_owner_account_name}</td>
                    <td>{item.mac_bank_name}</td>
                    <td>
                      <span className={`badge ${classBadgeStatePage}`}>
                        {
                          StatusAskCheckout.getStatusAskCheckoutString()[
                            item.mac_status
                          ]
                        }
                      </span>{" "}
                    </td>
                    <td>
                      {helperNumbers.toPersianNum(
                        item.mac_created_at.split(" ")[1] +
                          " " +
                          helpersTime.convertGregorianToJalali(
                            item.mac_created_at.split(" ")[0]
                          )
                      )}
                    </td>
                    <td>
                      <Link
                        to={`/finance/manage/marketer/ask-checkout/${item.mac_id}`}
                        className="btn btn-info"
                      >
                        <i className="fa fa-info"></i>
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  return (
    <>
      <Sidebar openItem="manage-finance" activeItem="marketer-ask-checkout" />

      <div className="content-wrapper">
        <TitleBar title="درخواست انتقال موجودی" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {allAskCheckoutUserPublisher.length == 0 && AskCheckoutID == 0
                ? generateDoseNotHaveAnyAskCheckout()
                : generateAllAskCheckoutUserPublisher()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
